export default __webpack_public_path__ + "static/media/fileIcon.309dabff.svg";